export default "__VITE_ASSET__DAL2gFcP__"